import { BusinessInfoRevisionKind, BusinessInfoRevisionStatus } from '~/swagger/companies/Api';

export const getBusinessInfoStatusLabelKey = (status: BusinessInfoRevisionStatus, type?: BusinessInfoRevisionKind): string => {
  switch (status) {
    case BusinessInfoRevisionStatus.Draft:
      if (type === BusinessInfoRevisionKind.Update) return 'Revision in progress';
      if (type === BusinessInfoRevisionKind.Supplement) return 'Action required';
      return 'Draft';
    case BusinessInfoRevisionStatus.PendingReview:
      if (type === BusinessInfoRevisionKind.Update) return 'Revision pending review';
      return 'Pending review';
    case BusinessInfoRevisionStatus.Rejected:
      if (type === BusinessInfoRevisionKind.Update) return 'Revision rejected';
      return 'Rejected';
    case BusinessInfoRevisionStatus.WaitingForInformation:
      if (type === BusinessInfoRevisionKind.Update) return 'Revision needs information';
      return 'Waiting for information';
    default:
      return '';
  }
};

export const getBusinessInfoContinueLabelKey = (type?: BusinessInfoRevisionKind): string => {
  if (type === BusinessInfoRevisionKind.Supplement) return 'Edit';
  if (type === BusinessInfoRevisionKind.Update) return 'Continue revision';
  return 'Continue';
};

export const getBusinessInfoWithdrawLabelKey = (): string => 'Withdraw submission';

export const getBusinessInfoAbandonLabelKey = (type?: BusinessInfoRevisionKind): string => {
  if (type === BusinessInfoRevisionKind.Update) return 'Discard revision';
  return 'Abandon draft';
};

export const getBusinessInfoAbandonConfirmTitleKey = (type?: BusinessInfoRevisionKind): string => getBusinessInfoAbandonLabelKey(type);

export const getBusinessInfoAbandonConfirmContentKey = (type?: BusinessInfoRevisionKind): string => {
  if (type === BusinessInfoRevisionKind.Update) {
    return 'Are you sure you want to discard this revision? This action cannot be undone.';
  }
  return 'Are you sure you want to abandon this draft? This action cannot be undone.';
};

export const getBusinessInfoAbandonConfirmDoneKey = (type?: BusinessInfoRevisionKind): string => getBusinessInfoAbandonLabelKey(type);

export const getBusinessInfoAbandonToastKey = (type?: BusinessInfoRevisionKind): string => {
  if (type === BusinessInfoRevisionKind.Update) return 'Revision discarded';
  return 'Draft abandoned';
};

export const getBusinessInfoSaveLabelKey = (type?: BusinessInfoRevisionKind): string => {
  if (type === BusinessInfoRevisionKind.Update) return 'Save revision';
  return 'Save draft';
};

export const getBusinessInfoRejectedReminderKey = (type?: BusinessInfoRevisionKind): string => {
  if (type === BusinessInfoRevisionKind.Update) {
    return 'Your revision was rejected. Please review and resubmit.';
  }
  return 'Your business information was rejected. Please review and resubmit.';
};

export const getBusinessInfoWaitingForInformationReminderKey = (type?: BusinessInfoRevisionKind): string => {
  if (type === BusinessInfoRevisionKind.Update) {
    return 'More information is needed. Continue the revision to review the request.';
  }
  return 'More information is needed. Open the draft to review the request and update your submission.';
};

export const getBusinessInfoPendingReviewReminderKey = (type?: BusinessInfoRevisionKind): string => {
  if (type === BusinessInfoRevisionKind.Update) {
    return 'Your revision has been submitted and is pending review.';
  }
  return 'Your business information has been submitted and is pending review.';
};
